<template>
  
  <div class="1">
 
    <div class="title-icon"><i>AI运营+AI办公-AI工具集 <img class="add" src="../../../../assets/coursePage/ai2/box6/add.svg"/></i></div>
    <div class="main-content-flow">
      <div class="bottom">
        <h1 class="title">
          <i></i>
          <p>01-国内优秀大模型使用</p>
        </h1>
        <div class="content">
          <div class="wrapper">
            <span>
              <a>文心一言</a>
              <a>讯飞星火</a>
              <a>智谱华章</a>
            </span>
          </div>
        </div>
      </div>
      <div class="bottom">
        <h1 class="title">
          <i></i>
          <p>02-热门AI工具使用</p>
        </h1>
        <div class="content">
          <div class="wrapper">
            <span>
              <a>ChatWithPDF</a>
              <a>Perplexity.ai</a>
              <a>Cursor</a>
              <a>Gamma.app</a>
              <a>Chat Doc</a>
              <a>Auto GPT</a>
            </span>
          </div>
        </div>
      </div>
      <div class="bottom">
        <h1 class="title">
          <i></i>
          <p>03-AI大模型运营</p>
        </h1>
        <div class="content">
          <div class="wrapper">
            <span>
              <a>新媒体运营-以某音为例</a>
            </span>
          </div>
        </div>
      </div>
      <div class="bottom">
        <h1 class="title">
          <i></i>
          <p>04-数字人实战</p>
        </h1>
        <div class="content">
          <div class="wrapper">
            <span>
              <a>基于元分身平台数字人实践</a>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="title-icon" style="margin-top: 20px;">大模型Prompt Engineering原理与实践</div>
    <div class="main-content">
      <div class="block">大模型提示工程指南</div>
      <div class="block">大模型提示工程项目应用实战</div>
    </div>

    <div class="title-icon" style="margin-top: 20px;">企业级大模型定制平台</div>
            <div class="main-content-flow">
              <div class="bottom">
              <div class="bottomInner">
                  <div class="platform">科大<br />讯飞</div>
                  <div class="content">
                    <div class="wrapper">
                      <span>
                        <a>星火大模型背景介绍</a>
                        <a>创建星火大模型个人助手</a>
                        <a>星火大模型典型应用场景案例</a>
                        <a>星火大模型原理挖掘</a>
                        <a>Python调用星火大模型API</a>
                        <a>多风格英译汉翻译机实战</a>
                       
                        <a>星火开源模型： iFlytekSpark-13B<img class="em" src="../../../../assets/coursePage/ai2/box6/add2.svg"/></a>
                        <a>非开源大模型微调-大模型定制训练平台<img  class="em" src="../../../../assets/coursePage/ai2/box6/add2.svg"/></a>
                        <a class="special2" @click="openVan(0)">金融行业动态风向评估<img src="../../../../assets/coursePage/ai2/box6/launch.png"/></a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="main-content-flow main-content-flow2">
              <div class="bottom">
              <div class="bottomInner">
                  <div class="platform">百度</div>
                  <div class="content">
                    <div class="wrapper">
                      <span>
                       
                        <a class="special">文心一言大模型应用与实战</a>
                        <a class="special">百度千帆大模型微调平台实战</a>
                        <a>头条新闻内容摘要<img class="em" src="../../../../assets/coursePage/ai2/box6/update2.svg"/></a>
                      
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="main-content-flow main-content-flow2">
              <div class="bottom">
              <div class="bottomInner">
                  <div class="platform">阿里云</div>
                  <div class="content">
                    <div class="wrapper">
                      <span>
                        <a class="special2" @click="openVan(2)">社交领域虚拟试衣系统<img src="../../../../assets/coursePage/ai2/box6/launch.png"/></a>
                        <a class="special">AI扩图</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  </div>
            
</template>

<script>
import pageTitle from "../../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  
  methods: {
    openVan(number) {
      this.$emit('openVan',number)
    },
    
  },
};
</script>

<style lang="less" scoped>
@import "index.less";

</style>